import Paragraph from "@tiptap/extension-paragraph";
import { mergeAttributes } from "@tiptap/react";
import { getTextSizeClassName } from "./TextSizeUtils";
export const SizedParagraph = Paragraph.extend({
    addOptions() {
        return {
            defaultTextSize: "bodySmall",
            HTMLAttributes: {},
        };
    },
    addAttributes() {
        return {
            class: {
                default: getTextSizeClassName(this.options.defaultTextSize),
                parseHTML: (element) => element.getAttribute("class"),
                renderHTML: (attributes) => {
                    return mergeAttributes(this.options.HTMLAttributes, attributes);
                },
            },
        };
    },
});
//# sourceMappingURL=SizedParagraph.js.map